import script from "./PasswordMailSubmitted.vue?vue&type=script&setup=true&lang=ts"
export * from "./PasswordMailSubmitted.vue?vue&type=script&setup=true&lang=ts"

import "./PasswordMailSubmitted.vue?vue&type=style&index=0&id=071ff0ca&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-071ff0ca"]])

export default __exports__